export const WHITESPACE = {
  '\u000A': 0.28, //
  '\u000D': 0.28, //
  '\u0020': 0.28, // SPACE
  '\u00A0': 0.28, // NO-BREAK SPACE
  '\u1680': 0.28, // OGHAM SPACE MARK
  '\u180E': 0.00, // MONGOLIAN VOWEL SEPARATOR
  '\u2000': 0.50, // EN QUAD
  '\u2001': 1.00, // EM QUAD
  '\u2002': 0.50, // EN SPACE
  '\u2003': 1.00, // EM SPACE
  '\u2004': 0.33, // THREE-PER-EM SPACE
  '\u2005': 0.25, // FOUR-PER-EM SPACE
  '\u2006': 0.16, // SIX-PER-EM SPACE
  '\u2007': 0.56, // FIGURE SPACE
  '\u2008': 0.28, // PUNCTUATION SPACE
  '\u2009': 0.20, // THIN SPACE
  '\u200A': 0.15, // HAIR SPACE
  '\u200B': 0.00, // ZERO WIDTH SPACE
  '\u202F': 0.16, // NARROW NO-BREAK SPACE
  '\u205F': 0.22, // MEDIUM MATHEMATICAL SPACE
  '\u3000': 1.00, // IDEOGRAPHIC SPACE
  '\uFEFF': 0.00 // ZERO WIDTH NO-BREAK SPACE
};
